const ErrorState = ({ icon: Icon, title, children, actions }) => (
    <div className="py-4">
        <div className="flex flex-col items-center text-center mb-5">
            <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-3">
                <Icon className="w-5 h-5 text-red-600" />
            </div>
            <h3 className="text-[17px] text-[#2D2D2D] mb-1.5">{title}</h3>
            <div className="text-[13px] text-[#6B6B6B] leading-5">{children}</div>
        </div>

        <div className="flex flex-col gap-2">{actions}</div>
    </div>
);

export default ErrorState;
